import React, {Component} from 'react'
import FormContext from 'components/FormContext'
import DeleteIcon from '@material-ui/icons/Delete'
import styles from './styles'
import {Typography, Button, IconButton} from 'components/OptimisedMui'
import {FileUploadField} from 'components'
import {ReadOnly} from 'components'
import {DialogHandler} from 'utils'
import { InputDialog } from 'components/InputDialog'
import {paramScoped} from 'utils/ComponentUtils'

export class Documents extends Component {
  state = {}
  downloadDialogHandler = new DialogHandler(this, 'downloadDialog')

  handleAddDownload = async() => {
    const {onChange, context} = this.props
    const name = await this.downloadDialogHandler.show()
    if (name) {
      onChange({...context, downloads: [...context.downloads, {name, tag: this.props.tag}]})
    }
  }

  handleDeleteDownload = paramScoped(download => event => {
    const {onChange, context} = this.props
    onChange({...context, downloads: context.downloads.filter(d => d !== download)})
  })

  render = () => {
    const {limitedUpdate} = this.props.context
    return (
      <ReadOnly on={this.props.review || limitedUpdate}>
        <FormContext
          context={this.props.context}
          onChange={this.props.onChange}
          errorContext={this.props.errorContext}
          metaRef={this.props.metaRef}
        >
          {this.props.children}
          <div className={styles({section: true, disabledArea: limitedUpdate})}>
            {this.props.context.downloads.map((download, i) =>
              download.tag === this.props.tag &&
                <div key={download.name}>
                  <Typography variant="subtitle1">{download.name}</Typography>
                  {!download.isDefault &&
                    <IconButton style={{float: 'right', marginTop: -5}} onClick={this.handleDeleteDownload(download)}>
                      <DeleteIcon/>
                    </IconButton>
                  }
                  <FileUploadField member={`downloads[${i}].attachment`}
                                   errorMember={`downloads['${download.name}'].attachment`}
                                   meta={{errorLabel: download.name}}
                                   type='file' fullWidth required={download.required}/>
                </div>
            )}
          </div>
          <InputDialog {...this.downloadDialogHandler.props} title="Document name" label="Document name" valueRequired/>
          {!limitedUpdate &&
            <Button vaiant="contained" className={styles.addButton} onClick={this.handleAddDownload} fullWidth>Add Another Document</Button>
          }
        </FormContext>
      </ReadOnly>
    )
  }
}